<template>
  <div class="template5">

    <!-- 主内容区 -->
    <div class="t5-content">
      <div class="t5-task-section">
        <!-- 任务标题区 -->
        <div class="t5-task-header">
          <div class="t5-task-title">首充充值任务</div>
          <div class="t5-task-tip">仅注册后第1笔充值奖励</div>
          <div class="t5-task-reward" @click="handleRefresh">
            <span class="reward-icon">⟳</span>
            <span>刷新奖励</span>
          </div>
        </div>

        <!-- 任务列表 -->
        <div class="t5-task-list">
          <div class="t5-task-item" v-for="(item, i) in taskList" :key="i">
            <div class="t5-task-icon">
              <img :src="item.icon" class="gift-icon" alt="" />
            </div>
            <div class="t5-task-info">
              <div class="t5-task-text">首次充值 ≥ {{ formatAmount(item.amount) }}, 奖励 <span class="reward-amount">{{ formatAmount(item.reward) }}</span></div>
              <div class="t5-task-progress">
                <div class="t5-progress-bar">
                  <div class="t5-progress-inner" :style="{ width: item.progress + '%' }"></div>
                  <div class="t5-progress-text">{{ item.current }}/{{ formatAmount(item.amount) }}</div>
                </div>
              </div>
            </div>
            <div class="t5-task-action">
              <button class="t5-btn-charge" @click="handleCharge">去充值</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 参与条件 -->
      <div class="t5-conditions" v-if="activityData.conditions">
        <div class="t5-conditions-title">参与条件</div>
        <div class="t5-conditions-list">
          <p v-for="(item, index) in activityData.conditions" :key="index">{{ item }}</p>
        </div>
      </div>

        <!-- 活动说明 -->
      <div class="t5-notice" v-if="activityData.notice">
        <div class="t5-notice-title">活动说明</div>
        <div class="t5-notice-list">
          <p v-for="(item, index) in activityData.notice" :key="index">{{ item }}</p>
        </div>
      </div>

      <!-- 条款及细则 -->
      <div class="t5-terms" v-if="activityData.terms">
        <div class="t5-terms-title">条款及细则</div>
        <div class="t5-terms-list">
          <p v-for="(item, index) in activityData.terms" :key="index">{{ item }}</p>
        </div>
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t5-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t5-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t5-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't5-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t5-recommend-img" alt="" />
            <div class="t5-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="t5-footer">
      <button class="t5-btn-back" @click="$router.back()">返回</button>
      <button class="t5-btn-claim" :class="{ disabled: !canClaim }" @click="handleClaim">一键领取</button>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template5',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPopup: false,
      popupItem: null,
      recommendList,
      taskList: [
        { id: 1, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 500, reward: 18, current: 0 },
        { id: 2, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 1000, reward: 38, current: 0 },
        { id: 3, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 5000, reward: 188, current: 0 },
        { id: 4, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 10000, reward: 388, current: 0 },
        { id: 5, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 30000, reward: 888, current: 0 },
        { id: 6, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 50000, reward: 1888, current: 0 },
        { id: 7, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 100000, reward: 5888, current: 0 },
        { id: 8, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 150000, reward: 7888, current: 0 },
        { id: 9, icon: '/static/newImg/active/template/tx_icon_ljcz.avif', amount: 180000, reward: 8888, current: 0 },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    canClaim() {
      return this.taskList.some(item => item.current >= item.amount);
    },
  },
  methods: {
    formatAmount(num) {
      return num.toLocaleString('en-US');
    },
    handleCharge() {
      this.$router.push('/recharge');
    },
    handleClaim() {
      if (!this.canClaim) return;
      // 领取逻辑
      this.$toast && this.$toast('领取成功');
    },
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=recommend`);
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    handleRefresh() {
      // 刷新奖励逻辑
      console.log('刷新奖励');
    },
    goClaimRecord() {
      // 跳转到活动页面并切换到领取记录选项卡
      this.$router.push('/activity?tab=record');
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template5 {
  background: #0a0a0a;
  min-height: 100vh;
  padding-bottom: 1.2rem;
}

// 顶部导航栏
.t5-navbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 0.9rem;
  padding: 0 0.3rem;
  background: #0a0a0a;
  z-index: 100;

  .t5-navbar-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.36rem;
    color: #fff;
    font-weight: 500;
  }

  .t5-navbar-left {
    width: 1.2rem;
  }

  .t5-navbar-right {
    font-size: 0.28rem;
    color: #d1ae52;
    cursor: pointer;
  }
}

.t5-content {
  padding: 0.2rem;
}

.t5-top-banner {
  margin-bottom: 0.3rem;
  background: #0a0a0a;
  padding: 0;

  .top-banner-img {
    width: 100%;
    display: block;
  }
}

// 任务标题区
.t5-task-header {
  background: #1e1f24;
  border-radius: 0.1rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  position: relative;

  .t5-task-title {
    font-size: 0.32rem;
    color: #fff;
    font-weight: 400;
  }

  .t5-task-tip {
    font-size: 0.26rem;
    color: #999;
    margin-top: 0.1rem;
  }

  .t5-task-reward {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    display: flex;
    align-items: center;
    color: #ffd700;
    font-size: 0.28rem;

    .reward-icon {
      font-size: 0.4rem;
      margin-right: 0.1rem;
      color: #d1ae52;
      display: inline-block;
    }
  }
}

// 任务列表
.t5-task-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.t5-task-item {
  background: #1e1f24;
  border-radius: 0.1rem;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.t5-task-icon {
  flex-shrink: 0;

  .gift-icon {
    width: 1rem;
    height: 1rem;
  }
}

.t5-task-info {
  flex: 1;
  min-width: 0;
}

.t5-task-text {
  font-size: 0.28rem;
  color: #fff;
  margin-bottom: 0.15rem;

  .reward-amount {
    color: #ffd700;
    font-weight: bold;
  }
}

.t5-task-progress {
  display: flex;
  align-items: center;
  gap: 0.15rem;
}

.t5-progress-bar {
  position: relative;
  width: 100%;
  height: 0.3rem;
  background: #0a0a0a;
  border-radius: 0.25rem;
  overflow: hidden;
}

.t5-progress-inner {
  height: 100%;
  background: #666666;
  border-radius: 0.075rem;
  transition: width 0.3s ease;
}

.t5-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.24rem;
  color: #fff;
  white-space: nowrap;
  z-index: 1;
}

.t5-task-action {
  flex-shrink: 0;
}

.t5-btn-charge {
  background: #d1ae52;
  color: #703904;
  border: none;
  border-radius: 0.08rem;
  padding: 0.12rem 0.25rem;
  font-size: 0.28rem;
  font-weight: 400;
  cursor: pointer;
}

// 参与条件
.t5-conditions {
  margin-top: 0.3rem;
  background: #0a0a0a;
  color: #999;
  border-radius: 0.1rem;
  padding: 0.2rem;

  .t5-conditions-title {
    display: inline-block;
    background: linear-gradient(90deg, #d1ae52, #b8923e);
    color: #000;
    font-size: 0.3rem;
    font-weight: 400;
    padding: 0.1rem 0.4rem 0.1rem 0.2rem;
    border-radius: 0.05rem;
    position: relative;
    margin-bottom: 0.2rem;

    &::after {
      content: '';
      position: absolute;
      right: -0.15rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 0.25rem solid transparent;
      border-bottom: 0.25rem solid transparent;
      border-left: 0.2rem solid #b8923e;
    }
  }

  .t5-conditions-list {
    color: #999;
    font-size: 0.28rem;
    line-height: 1.6;

    p {
      margin: 0 0 0.1rem 0;
    }
  }
}

// 活动说明
.t5-notice {
  margin-top: 0.3rem;
  background: #0a0a0a;
  color: #999;
  border-radius: 0.1rem;
  padding: 0.2rem;

  .t5-notice-title {
    display: inline-block;
    background: linear-gradient(90deg, #d1ae52, #b8923e);
    color: #000;
    font-size: 0.3rem;
    font-weight: 400;
    padding: 0.1rem 0.4rem 0.1rem 0.2rem;
    border-radius: 0.05rem;
    position: relative;
    margin-bottom: 0.2rem;

    &::after {
      content: '';
      position: absolute;
      right: -0.15rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 0.25rem solid transparent;
      border-bottom: 0.25rem solid transparent;
      border-left: 0.2rem solid #b8923e;
    }
  }

  .t5-notice-list {
    color: #999;
    font-size: 0.28rem;
    line-height: 1.6;

    p {
      margin: 0 0 0.1rem 0;
    }
  }
}

// 条款及细则
.t5-terms {
  margin-top: 0.3rem;
  background: #0a0a0a;
  color: #999;
  border-radius: 0.1rem;
  padding: 0.2rem;

  .t5-terms-title {
    display: inline-block;
    background: linear-gradient(90deg, #d1ae52, #b8923e);
    color: #000;
    font-size: 0.3rem;
    font-weight: 400;
    padding: 0.1rem 0.4rem 0.1rem 0.2rem;
    border-radius: 0.05rem;
    position: relative;
    margin-bottom: 0.2rem;

    &::after {
      content: '';
      position: absolute;
      right: -0.15rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 0.25rem solid transparent;
      border-bottom: 0.25rem solid transparent;
      border-left: 0.2rem solid #b8923e;
    }
  }

  .t5-terms-list {
    color: #999;
    font-size: 0.28rem;
    line-height: 1.6;

    p {
      margin: 0 0 0.1rem 0;
    }
  }
}

// 底部推荐图
.t5-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t5-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 0.5rem;
  }

  .t5-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .t5-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
    border: 1px solid transparent;
    box-sizing: border-box;
  }

  .t5-recommend-item.t5-recommend-active .t5-recommend-img {
    border: 1px solid #d1ae52;
  }

  .t5-recommend-name {
    font-size: 0.26rem;
    color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    max-width: 2.5rem;
    line-height: 1.3;
  }
}

// 底部操作栏
.t5-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 0.2rem;
  padding: 0.3rem;
  padding-bottom: 0.5rem;
  background: #0a0a0a;
  border-top: 1px solid #1e1f24;
  max-width: 750px;
  margin: 0 auto;

  button {
    flex: 1;
    padding: 0.2rem;
    border: none;
    border-radius: 0.25rem;
    font-size: 0.32rem;
    font-weight: 400;
    cursor: pointer;
  }

  .t5-btn-back {
    background: transparent;
    color: #d1ae52;
    border: 1px solid #d1ae52;
  }

  .t5-btn-claim {
    background: #666666;
    color: #1a1a1a;

    &.disabled {
      background: #666666;
      color: #1a1a1a;
      cursor: not-allowed;
    }

    &:not(.disabled) {
      background: #d1ae52;
      color: #703904;
    }
  }
}

// 弹框
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  position: relative;
  width: 80%;
  max-width: 6rem;
  background: #1a1a1a;
  border-radius: 0.15rem;
  padding: 0.3rem;
}

.popup-close {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  width: 0.4rem;
  height: 0.4rem;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.popup-body {
  text-align: center;
}

.popup-img {
  width: 100%;
  border-radius: 0.1rem;
}

.popup-name {
  color: #fff;
  font-size: 0.3rem;
  margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template5.vue